import { useSubjectUpdate } from '@healthblocks-io/core'

const useIgnoreSyncAgenda = () => {
  const [{ data, mutate }, updateSubject] = useSubjectUpdate()

  function setIgnoreSyncAgenda(ignore: boolean) {
    // Refresh the user before updating the actor to make sure we have the latest metadata
    mutate().then((latestActor) =>
      updateSubject({
        meta: {
          ...latestActor?.meta,
          hasIgnoredSyncAgenda: ignore,
        },
      }),
    )
  }

  return {
    hasIgnoredSyncAgenda: data?.meta?.hasIgnoredSyncAgenda,
    setIgnoreSyncAgenda,
  }
}

export { useIgnoreSyncAgenda }
